import { Brand, ResolverTag, Site } from '@ps/web-core-enums';
import { lastValueFrom } from 'rxjs';
import URL from 'url-parse';

import type { ObservableRequest } from '@swf/core/hooks/useRequest';
import type { Select } from '@swf/core/store';

import ENDPOINTS from '../constants/endpoints';
import type { InviteLink } from '../types/common';

export interface InviteOptions {
  type: InviteLink;
  [name: string]: unknown;
}

export const createInviteUrl = async (
  request: ObservableRequest,
  aliases: ReturnType<Select['cms']['getAliases']>,
  { type, ...options }: InviteOptions
) => {
  const args = btoa(JSON.stringify({ type, ...options }));

  try {
    const {
      body: { url: origin }
    } = await lastValueFrom(
      request<{ url: string }>({
        service: ENDPOINTS.resolveTags,
        body: {
          tag: ResolverTag.HomeGamesInvite,
          brand: Brand.PokerStars,
          site: Site.COM
        }
      })
    );

    const url = new URL(origin);
    url.set('pathname', aliases.homeGamesInvite);
    url.set('query', { args });

    return url.toString();
  } catch (error) {
    return;
  }
};
